import MessageDialog from "@/components/dialog/MessageDialog";
import Footer from "@/components/footer/Footer";
import NotFound from "@/pages/NotFound";
import { createRootRoute, Outlet } from "@tanstack/react-router";
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";

export const Route = createRootRoute({
  component: () => (
    <div className="flex min-h-screen flex-col justify-between">
      <div className="min-h-[62px]">
        <div id="skipToContent"></div>
      </div>
      <MessageDialog />
      <main className="min-w-content grow overflow-x-hidden">
        <div className="mx-auto my-[6.25rem] flex max-w-[500px] flex-none flex-col items-center px-4">
          <Outlet />
          <TanStackRouterDevtools />
        </div>
      </main>
      <Footer />
    </div>
  ),
  notFoundComponent: () => <NotFound />,
});
